import { render, staticRenderFns } from "./GyroAccess.vue?vue&type=template&id=2d6ac3f6&"
import script from "./GyroAccess.vue?vue&type=script&lang=js&"
export * from "./GyroAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports